module.exports = __webpack_public_path__ + "static/71gde-75e2f6414fc5d4072f7105821355a8be.gif";